import { ref, computed, type Ref } from 'vue'

export function useControlled<T>(thunk: () => T, defaultValue?: T) {
  const controlledValue = computed(() => thunk())

  const isControlled = computed(() => controlledValue.value !== undefined)

  const internalValue = ref(controlledValue.value ?? defaultValue) as Ref<T>

  const value = computed({
    get: () => {
      return isControlled.value ? controlledValue.value : internalValue.value
    },
    set: (newValue) => {
      if (isControlled.value === false) {
        internalValue.value = newValue as T // Update internal value if uncontrolled
      }
    }
  })

  return {
    value,
    isControlled
  }
}
